// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import initCodeHighlighting from "./codeHighlight";
import initMahjongRenderer, { parseMahjongNotation, renderMahjongHtml, getTilesBasePath } from "./mahjong";
import initFeaturedSlider from "./featuredSlider";
import initTagFilter from "./tagFilter";
import initThemeToggle, { applyTheme, getSavedTheme } from "./themeToggle";

// Expose utilities on window for custom user scripts if needed
if (typeof window !== "undefined") {
    window.initCodeHighlighting = initCodeHighlighting;
    window.initMahjongRenderer = initMahjongRenderer;
    window.parseMahjongNotation = parseMahjongNotation;
    window.renderMahjongHtml = renderMahjongHtml;
    window.getTilesBasePath = getTilesBasePath;
    window.initFeaturedSlider = initFeaturedSlider;
    window.initTagFilter = initTagFilter;
    window.initThemeToggle = initThemeToggle;
    window.applyTheme = applyTheme;
    window.getSavedTheme = getSavedTheme;
}

// Call functions on DOMContentLoaded / initial load
function init() {
    initThemeToggle();
    menuOpen();
    infiniteScroll();
    initMahjongRenderer();
    initCodeHighlighting();
    initFeaturedSlider();
    initTagFilter();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
